import styled from 'styled-components';
export const IndustriesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-xl);

  padding-block: var(--space-xxxl);

  /* background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.92) 0%,
    rgba(249, 250, 251, 1) 100%
  ); */

  /* border: 1px solid rgba(15, 23, 42, 0.08); */
  /* border-radius: 28px; */

  /* box-shadow: 0 18px 44px rgba(15, 23, 42, 0.05); */

  @media screen and (max-width: 700px) {
    padding: var(--space-xl);
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-l);
  }
`;

export const IndustriesIntro = styled.p`
  max-width: 760px;

  margin: 0;

  color: var(--grey5);

  font-size: 1rem;
  line-height: 1.85;
  font-weight: 500;
`;

export const IndustryGrid = styled.div`
  display: flex;
  flex-wrap: wrap;

  gap: var(--space-s);
`;

export const IndustryItem = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: var(--space-xs) var(--space-m);

  border-radius: 999px;

  background: linear-gradient(
    180deg,
    rgba(255, 248, 235, 0.95) 0%,
    rgba(248, 230, 208, 0.92) 100%
  );

  border: 1px solid rgba(230, 139, 7, 0.14);

  color: var(--grey6);

  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.2;

  transition:
    transform 0.2s ease,
    background-color 0.2s ease;

  &:hover {
    transform: translateY(-1px);

    background: linear-gradient(
      180deg,
      rgba(255, 240, 194, 0.96) 0%,
      rgba(248, 230, 208, 1) 100%
    );
  }
`;
